import { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import { useNavigate } from "react-router-dom";
import { IoEye, IoEyeOff } from "react-icons/io5";
import "./Login.scss";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      await signInWithEmailAndPassword(auth, email, password);

      sessionStorage.setItem("justLoggedIn", "1");

      navigate("/", { replace: true });
    } catch (err) {
      console.error("Login error:", err.message);
      setError("Nesprávný e-mail nebo heslo");
    }
  };

  return (
    <main className="login">
      <div className="login__container">
        <div className="login__intro">
          <h1>
            Firemní e-shop pro zaměstnance a externí spolupracovníky Codaco.
          </h1>
          <p>
            Najdete zde přehled firemního merche a doplňků pro práci i
            reprezentaci značky.
          </p>
        </div>

        {/* === Login form === */}
        <form className="login__form" onSubmit={handleSubmit}>
          <h2 className="login__title">Přihlášení</h2>

          <label htmlFor="email" className="login__label">
            E-mail
          </label>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="login__input"
            autoComplete="email"
            required
          />

          <label htmlFor="password" className="login__label">
            Heslo
          </label>
          <div className="login__password-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              id="password"
              name="password"
              placeholder="Heslo"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="login__input"
              autoComplete="current-password"
              required
            />
            <button
              type="button"
              className="login__toggle"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <IoEyeOff /> : <IoEye />}
            </button>
          </div>

          {error && <p className="login__error">{error}</p>}

          <button type="submit" className="btn btn--primary login__button">
            Přihlásit se
          </button>
        </form>
      </div>
    </main>
  );
}
